module.exports = "https://r.zoocdn.com/_next/static/images/Popular_locations_icon-93aff2a815921bd65e3b61ddab3da567.png";